// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__7xdrq","btnDisabled":"Btn_btnDisabled__AUrFI","icon":"Btn_icon__FMZOh","iconImage":"Btn_iconImage__upNKz"};